/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.123.3-v202604150000-CDH
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import * as models from './models';

/**
 * The list of searches based on properties
 */
export interface PropertySearchV1 {
    /**
     * If provided, only search for items that are descendants of this asset
     */
    "ancestorId"?: string;
    /**
     * A list of ancestor predicate filters. Each predicate specifies property filters for an ancestor and an optional level (1 = direct parent, 2 = grandparent, etc.). When provided with ancestorId, constrains results to items whose ancestors at the specified level match the given property filters.
     */
    "ancestorPredicates"?: Array<models.AncestorFilterInputV1>;
    /**
     * If provided, only search for items that are scoped to the workbooks contained in this folder
     */
    "folderId"?: string;
    /**
     * If true, the items found by this search will be included in the output. If false, then the results will be excluded from the output (even if found by another search)
     */
    "isInclude": boolean;
    /**
     * A list of predicates by which to filter the items
     */
    "predicates"?: Array<models.PropertyFilterInputV1>;
    /**
     * The order in which this search should be executed. When the same item appears in multiple searches, the search with the highest order value wins. If not specified, searches are ordered by their creation time (UUID).
     */
    "searchOrder"?: number;
    /**
     * The type of search
     */
    "searchType": SearchTypeEnum;
    /**
     * A list of types by which to filter the items
     */
    "types": Array<string>;
}

export enum SearchTypeEnum {
    SWAPACROSSASSETS = 'SWAP_ACROSS_ASSETS',
    FIXEDLIST = 'FIXED_LIST',
    PROPERTY = 'PROPERTY',
    MATERIALIZEDTABLEUUIDCOLUMN = 'MATERIALIZED_TABLE_UUID_COLUMN',
    HIERARCHY = 'HIERARCHY',
    STOREDTABLE = 'STORED_TABLE'
}
